import apiCall from "@/utils/api";

export async function fetchSelfHelpGroups({ page = 1, search = "" } = {}) {
  const params = new URLSearchParams();
  params.set("page", String(page));

  if (search) {
    params.set("type", "search");
    params.set("search", search);
  }

  return await apiCall({
    url: `/api/client/self-help-group?${params.toString()}`,
    method: "GET",
  });
}

export async function fetchSelfHelpGroup(id) {
  return await apiCall({
    url: `/api/client/self-help-group/${id}`,
    method: "GET",
  });
}

export async function fetchSelfHelpGroupFormData() {
  return await apiCall({
    url: "/api/client/self-help-group/form-data",
    method: "GET",
  });
}

export async function createSelfHelpGroup(payload) {
  return await apiCall({
    url: "/api/client/self-help-group",
    method: "POST",
    data: payload,
  });
}

export async function renewSelfHelpGroup({ id, payload }) {
  return await apiCall({
    url: `/api/client/self-help-group/${id}/renew`,
    method: "POST",
    data: payload,
  });
}

export async function downloadSelfHelpGroupAcknowledgement(kiripayGroupNo) {
  const blob = await apiCall({
    url: `/api/client/self-help-group/acknowledgement-slip/${encodeURIComponent(
      kiripayGroupNo,
    )}`,
    method: "GET",
    responseType: "blob",
  });

  const filename = `SHG_Acknowledgement_Slip_${kiripayGroupNo}.pdf`;
  const downloadUrl = window.URL.createObjectURL(new Blob([blob]));
  const link = document.createElement("a");
  link.href = downloadUrl;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(downloadUrl);
}

export function getFeeForType({ feeMappings, shgTypeId, paymentTypeId }) {
  const match = feeMappings.find(
    (item) =>
      Number(item.shg_type_id) === Number(shgTypeId) &&
      Number(item.shg_payment_type_id) === Number(paymentTypeId),
  );

  return Number(match?.fee_amount ?? 0);
}
